var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trackdeletemodal-container"},[_c('b-button',{staticClass:"is-danger",attrs:{"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.open}},[_vm._v("Delete Track(s)")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }